import React, { useState, useEffect } from 'react'
import useFirebase from '../../../firebase/useFirebase'
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'

const PhoneUsersPage = () => {
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const { profil,readData } = useFirebase()

    useEffect(() => {
        readData(keyUid) 
    },[])

    return (
        <div className='container_fluid'>

                {/* HEADER RETOUR */}
                <HeaderReturn title='Retour home' link={'/homeUser/'+keyUid+'/'+tokenUser}/>

                {profil.filter(p => p.id === 'profil').map(p => (
                    <div onclick={window.open("tel:"+p.telephoneSalon)}></div>
                ))}
        </div>
    )
}

export default PhoneUsersPage